import React from 'react';
import { BookmarkMode, NotesMode } from '../types';
import { BookmarkModeEnum, NotesModeEnum } from '../constants';

const IndicatorsModeContext = React.createContext<{
  bookmarkMode: BookmarkMode;
  notesMode: NotesMode;
  setBookmarkMode: (newMode: BookmarkMode) => void;
  setNotesMode: (newMode: NotesMode) => void;
}>({
  bookmarkMode: { mode: BookmarkModeEnum.DISABLED },
  setBookmarkMode: () => null,
  notesMode: { mode: NotesModeEnum.DISABLED },
  setNotesMode: () => null,
});

export default IndicatorsModeContext;
